import { render, staticRenderFns } from "./SystemSelection.vue?vue&type=template&id=6b976304&scoped=true"
import script from "./SystemSelection.vue?vue&type=script&lang=js"
export * from "./SystemSelection.vue?vue&type=script&lang=js"
import style0 from "./SystemSelection.vue?vue&type=style&index=0&id=6b976304&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b976304",
  null
  
)

export default component.exports